import { render } from "./HeaderModal.vue?vue&type=template&id=45a5a38e&scoped=true"
import script from "./HeaderModal.vue?vue&type=script&lang=js"
export * from "./HeaderModal.vue?vue&type=script&lang=js"

import "@/assets/css/newdesign.scss?vue&type=style&index=0&id=45a5a38e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a5a38e"]])

export default __exports__